import { useEffect } from 'react';

const Header = () => {
  const isNonMobile = window.matchMedia('(min-width: 1020px)').matches;
  useEffect(() => {
    const nav = document.querySelector('#nav');

    const onScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > 10) {
        nav.classList.add('scrolled-down');
      } else {
        nav.classList.remove('scrolled-down');
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <header id='nav' className='header-navbar '>
      {isNonMobile && (
        <div className='logo-container '>
          <button className='logo hover-underline-animation '>
            <span className='html-sizefixer'>&lt;h2&gt;</span>
            <span className='anime-grad'>MIKE </span>
            <span className='header-logo_small anime-grad'>PALLIPARAMBIL</span>
            <span className='header-logo_small' style={{ color: '#430d79' }}>
              .
            </span>
            <span className='html-sizefixer'>&lt;/h2&gt;</span>
          </button>
        </div>
      )}

      <div className='menu-container ' data-aos='flip-up'>
        <nav className='menu '>
          <li>
            <a href='#home' className='hover-underline-animation anime-grad'>
              <span className='firstletter'>H</span>ome
            </a>
          </li>
          <li>
            <a
              href='#portfolio'
              className='hover-underline-animation anime-grad'
            >
              {' '}
              <span className='firstletter'>P</span>ortfolio
            </a>
          </li>
          <li>
            <a href='#aboutme' className='hover-underline-animation anime-grad'>
              {' '}
              <span className='firstletter'>A</span>bout me
            </a>
          </li>
        </nav>
      </div>
    </header>
  );
};

export default Header;
